// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.battery-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;
}

.battery-section-title {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1.2rem;
  font-weight: 600;
  color: #333;
}

.battery-section-title mat-icon {
  color: #1976d2;
}

.graph-content {
  margin-top: 1rem;
}

.graph-card {
  background: #fff;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
  margin-bottom: 20px;
  height: 100%;
}
.graph-card canvas {
  width: 100% !important;
  height: auto !important;
}

.battery-header {
  margin-bottom: 1rem;
}

.battery-section-title {
  display: flex;
  align-items: center;
  font-size: 1.2rem;
  font-weight: bold;
}

.battery-section-title mat-icon {
  margin-right: 8px;
}

.chart-title {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  font-size: 1.1rem;
}
.chart-title mat-icon {
  vertical-align: -webkit-baseline-middle;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/graph-battery-coverage/graph-battery-coverage.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,0CAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;AACF;AACE;EACE,sBAAA;EACA,uBAAA;AACJ;;AAWA;EACE,mBAAA;AARF;;AAWA;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;AARF;;AAWA;EACE,iBAAA;AARF;;AAWA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,iBAAA;AARF;AAUE;EAEE,uCAAA;AATJ","sourcesContent":[".battery-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 1rem;\n}\n\n.battery-section-title {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 1.2rem;\n  font-weight: 600;\n  color: #333;\n}\n\n.battery-section-title mat-icon {\n  color: #1976d2;\n}\n\n.graph-content {\n  margin-top: 1rem;\n}\n\n.graph-card {\n  background: #fff;\n  padding: 20px;\n  border-radius: 12px;\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\n  text-align: center;\n  margin-bottom: 20px;\n  height: 100%;\n\n  canvas {\n    width: 100% !important;\n    height: auto !important;\n  }\n}\n\n// .graph-card--small {\n//   padding: 12px 16px;\n\n//   // canvas {\n//   //   max-height: 160px!important; // Ajusta la altura a tu gusto\n//   // }\n// }\n\n.battery-header {\n  margin-bottom: 1rem;\n}\n\n.battery-section-title {\n  display: flex;\n  align-items: center;\n  font-size: 1.2rem;\n  font-weight: bold;\n}\n\n.battery-section-title mat-icon {\n  margin-right: 8px;\n}\n\n.chart-title {\n  display: flex;\n  align-items: center;\n  justify-content: center; // opcional si quieres centrar todo horizontalmente\n  gap: 0.5rem;\n  font-size: 1.1rem;\n\n  mat-icon {\n    // font-size: 1.2rem;\n    vertical-align: -webkit-baseline-middle;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
